// Registry mapping calculator slug -> React component
import MortgageCalc from './financial/MortgageCalc';
import LoanCalc from './financial/LoanCalc';
import AutoLoanCalc from './financial/AutoLoanCalc';
import InterestCalc from './financial/InterestCalc';
import CompoundInterestCalc from './financial/CompoundInterestCalc';
import RetirementCalc from './financial/RetirementCalc';
import AmortizationCalc from './financial/AmortizationCalc';
import InvestmentCalc from './financial/InvestmentCalc';
import InflationCalc from './financial/InflationCalc';
import IncomeTaxCalc from './financial/IncomeTaxCalc';
import SalaryCalc from './financial/SalaryCalc';
import SalesTaxCalc from './financial/SalesTaxCalc';
import CurrencyCalc from './financial/CurrencyCalc';
import ROICalc from './financial/ROICalc';
import DiscountCalc from './financial/DiscountCalc';
import PercentOffCalc from './financial/PercentOffCalc';
import PaymentCalc from './financial/PaymentCalc';
import APRCalc from './financial/APRCalc';
import HouseAffordabilityCalc from './financial/HouseAffordabilityCalc';
import DownPaymentCalc from './financial/DownPaymentCalc';
import RefinanceCalc from './financial/RefinanceCalc';
import Retirement401kCalc from './financial/Retirement401kCalc';
import RothIRACalc from './financial/RothIRACalc';
import IRACalc from './financial/IRACalc';
import RMDCalc from './financial/RMDCalc';
import BudgetCalc from './financial/BudgetCalc';
import CreditCardCalc from './financial/CreditCardCalc';
import DebtPayoffCalc from './financial/DebtPayoffCalc';
import CreditCardsPayoffCalc from './financial/CreditCardsPayoffCalc';
import DebtConsolidationCalc from './financial/DebtConsolidationCalc';
import StudentLoanCalc from './financial/StudentLoanCalc';
import FHALoanCalc from './financial/FHALoanCalc';
import VAMortgageCalc from './financial/VAMortgageCalc';
import PersonalLoanCalc from './financial/PersonalLoanCalc';
import MortgagePayoffCalc from './financial/MortgagePayoffCalc';
import MortgageAmortizationCalc from './financial/MortgageAmortizationCalc';
import HELOCCalc from './financial/HELOCCalc';
import HomeEquityLoanCalc from './financial/HomeEquityLoanCalc';
import CanadianMortgageCalc from './financial/CanadianMortgageCalc';
import UKMortgageCalc from './financial/UKMortgageCalc';
import BusinessLoanCalc from './financial/BusinessLoanCalc';
import BoatLoanCalc from './financial/BoatLoanCalc';
import RepaymentCalc from './financial/RepaymentCalc';
import TakeHomePayCalc from './financial/TakeHomePayCalc';
import MarginCalc from './financial/MarginCalc';
import LeaseCalc from './financial/LeaseCalc';
import AnnuityCalc from './financial/AnnuityCalc';
import FinanceCalc from './financial/FinanceCalc';
import InterestRateCalc from './financial/InterestRateCalc';
import BondCalc from './financial/BondCalc';
import SimpleInterestCalc from './financial/SimpleInterestCalc';
import PresentValueCalc from './financial/PresentValueCalc';
import FutureValueCalc from './financial/FutureValueCalc';
import CDCalc from './financial/CDCalc';
import SavingsCalc from './financial/SavingsCalc';
import IRRCalc from './financial/IRRCalc';
import DebtToIncomeCalc from './financial/DebtToIncomeCalc';
import DepreciationCalc from './financial/DepreciationCalc';
import VATCalc from './financial/VATCalc';
import CommissionCalc from './financial/CommissionCalc';
import CollegeCostCalc from './financial/CollegeCostCalc';
import RentVsBuyCalc from './financial/RentVsBuyCalc';
import RentCalc from './financial/RentCalc';
import SocialSecurityCalc from './financial/SocialSecurityCalc';
import AverageReturnCalc from './financial/AverageReturnCalc';
import PaybackPeriodCalc from './financial/PaybackPeriodCalc';
import RentalPropertyCalc from './financial/RentalPropertyCalc';
import RealEstateCalc from './financial/RealEstateCalc';
import AutoLeaseCalc from './financial/AutoLeaseCalc';
import EstateTaxCalc from './financial/EstateTaxCalc';
import MarriageTaxCalc from './financial/MarriageTaxCalc';
import PensionCalc from './financial/PensionCalc';
import AnnuityPayoutCalc from './financial/AnnuityPayoutCalc';
import MutualFundCalc from './financial/MutualFundCalc';
import CashBackVsLowInterestCalc from './financial/CashBackVsLowInterestCalc';

import BMICalc from './fitness/BMICalc';
import AnorexicBMICalc from './fitness/AnorexicBMICalc';
import ArmyBodyFatCalc from './fitness/ArmyBodyFatCalc';
import BACCalc from './fitness/BACCalc';
import BodyTypeCalc from './fitness/BodyTypeCalc';
import CarbohydrateCalc from './fitness/CarbohydrateCalc';
import FatIntakeCalc from './fitness/FatIntakeCalc';
import HealthyWeightCalc from './fitness/HealthyWeightCalc';
import OverweightCalc from './fitness/OverweightCalc';
import DueDateCalc from './fitness/DueDateCalc';
import ConceptionCalc from './fitness/ConceptionCalc';
import PregnancyWeightGainCalc from './fitness/PregnancyWeightGainCalc';
import GFRCalc from './fitness/GFRCalc';
import CalorieCalc from './fitness/CalorieCalc';
import BodyFatCalc from './fitness/BodyFatCalc';
import BMRCalc from './fitness/BMRCalc';
import IdealWeightCalc from './fitness/IdealWeightCalc';
import PaceCalc from './fitness/PaceCalc';
import PregnancyCalc from './fitness/PregnancyCalc';
import TDEECalc from './fitness/TDEECalc';
import MacroCalc from './fitness/MacroCalc';
import ProteinCalc from './fitness/ProteinCalc';
import OneRepMaxCalc from './fitness/OneRepMaxCalc';
import TargetHRCalc from './fitness/TargetHRCalc';
import BSACalc from './fitness/BSACalc';
import LBMCalc from './fitness/LBMCalc';
import CaloriesBurnedCalc from './fitness/CaloriesBurnedCalc';
import OvulationCalc from './fitness/OvulationCalc';
import PeriodCalc from './fitness/PeriodCalc';
import BraSizeCalc from './fitness/BraSizeCalc';

import ScientificCalc from './math/ScientificCalc';
import GraphTool from './math/GraphTool';
import FractionCalc from './math/FractionCalc';
import PercentageCalc from './math/PercentageCalc';
import RandomNumberCalc from './math/RandomNumberCalc';
import TriangleCalc from './math/TriangleCalc';
import StandardDeviationCalc from './math/StandardDeviationCalc';
import QuadraticCalc from './math/QuadraticCalc';
import AreaCalc from './math/AreaCalc';
import VolumeCalc from './math/VolumeCalc';
import StatisticsCalc from './math/StatisticsCalc';
import RootCalc from './math/RootCalc';
import ExponentCalc from './math/ExponentCalc';
import LogarithmCalc from './math/LogarithmCalc';
import ModuloCalc from './math/ModuloCalc';
import PrimeFactorizationCalc from './math/PrimeFactorizationCalc';
import CircleCalc from './math/CircleCalc';
import RightTriangleCalc from './math/RightTriangleCalc';
import PythagoreanCalc from './math/PythagoreanCalc';
import DistanceCalc from './math/DistanceCalc';
import SlopeCalc from './math/SlopeCalc';
import RatioCalc from './math/RatioCalc';
import BinaryCalc from './math/BinaryCalc';
import HexCalc from './math/HexCalc';
import GCFCalc from './math/GCFCalc';
import CommonFactorCalc from './math/CommonFactorCalc';
import MeanMedianModeRangeCalc from './math/MeanMedianModeRangeCalc';
import LCMCalc from './math/LCMCalc';
import FactorCalc from './math/FactorCalc';
import ProbabilityCalc from './math/ProbabilityCalc';
import SurfaceAreaCalc from './math/SurfaceAreaCalc';
import MatrixCalc from './math/MatrixCalc';
import HalfLifeCalc from './math/HalfLifeCalc';
import RoundingCalc from './math/RoundingCalc';
import PermutationCalc from './math/PermutationCalc';
import ZScoreCalc from './math/ZScoreCalc';
import SampleSizeCalc from './math/SampleSizeCalc';
import NumberSequenceCalc from './math/NumberSequenceCalc';
import ConfidenceIntervalCalc from './math/ConfidenceIntervalCalc';
import LongDivisionCalc from './math/LongDivisionCalc';
import DiceRollerCalc from './math/DiceRollerCalc';
import BasicCalc from './math/BasicCalc';
import BigNumberCalc from './math/BigNumberCalc';
import ScientificNotationCalc from './math/ScientificNotationCalc';
import PercentErrorCalc from './math/PercentErrorCalc';
import PValueCalc from './math/PValueCalc';
import AverageCalc from './math/AverageCalc';
import { FractionSimplifyCalc, DecimalToFractionCalc, FractionToDecimalCalc, MixedNumberCalc, BigFractionCalc } from './math/FractionSubs';
import {
  CubeVolume, SphereVolume, ConeVolume, CylinderVolume, EllipsoidVolume, CapsuleVolume,
  RectTankVolume, SphericalCapVolume, ConicalFrustumVolume, SquarePyramidVolume, TubeVolume,
  SlopeTwoPoints, SlopePointSlope,
  Distance2D, Distance3D, DistanceLatLon,
  AreaSector, AreaTriangle,
  RatioScaling
} from './math/MathSubs';

import DewPointCalc from './other/DewPointCalc';
import HeightCalc from './other/HeightCalc';
import TimeZoneCalc from './other/TimeZoneCalc';
import StairCalc from './other/StairCalc';
import RoofingCalc from './other/RoofingCalc';

import AgeCalc from './other/AgeCalc';
import DateCalc from './other/DateCalc';
import TimeCalc from './other/TimeCalc';
import HoursCalc from './other/HoursCalc';
import GPACalc from './other/GPACalc';
import GradeCalc from './other/GradeCalc';
import PasswordCalc from './other/PasswordCalc';
import ConversionCalc from './other/ConversionCalc';
import LoveCalc from './other/LoveCalc';
import DayCounter from './other/DayCounter';
import GasMileageCalc from './other/GasMileageCalc';
import TireSizeCalc from './other/TireSizeCalc';
import ConcreteCalc from './other/ConcreteCalc';
import RomanNumeralCalc from './other/RomanNumeralCalc';
import WindChillCalc from './other/WindChillCalc';
import HeatIndexCalc from './other/HeatIndexCalc';
import SquareFootageCalc from './other/SquareFootageCalc';
import SleepCalc from './other/SleepCalc';
import OhmsLawCalc from './other/OhmsLawCalc';
import FuelCostCalc from './other/FuelCostCalc';
import IPSubnetCalc from './other/IPSubnetCalc';
import BandwidthCalc from './other/BandwidthCalc';
import TimeCardCalc from './other/TimeCardCalc';
import BTUCalc from './other/BTUCalc';
import HorsepowerCalc from './other/HorsepowerCalc';
import CountdownCalc from './other/CountdownCalc';
import ShoeSizeCalc from './other/ShoeSizeCalc';
import TimeDurationCalc from './other/TimeDurationCalc';
import RomanNumeralDateCalc from './other/RomanNumeralDateCalc';
import EngineHorsepowerCalc from './other/EngineHorsepowerCalc';
import SpeedCalc from './other/SpeedCalc';
import DensityCalc from './other/DensityCalc';
import MassCalc from './other/MassCalc';
import WeightConverterCalc from './other/WeightConverterCalc';
import WeightCalc from './other/WeightCalc';
import MolarityCalc from './other/MolarityCalc';
import MolecularWeightCalc from './other/MolecularWeightCalc';
import TileCalc from './other/TileCalc';
import MulchCalc from './other/MulchCalc';
import GravelCalc from './other/GravelCalc';
import ResistorCalc from './other/ResistorCalc';
import Base64Calc from './other/Base64Calc';
import UrlEncodeDecodeCalc from './other/UrlEncodeDecodeCalc';
import VoltageDropCalc from './other/VoltageDropCalc';
import ElectricityCalc from './other/ElectricityCalc';
import GDPCalc from './other/GDPCalc';
import TipCalc from './other/TipCalc';
import GolfHandicapCalc from './other/GolfHandicapCalc';
import DayOfWeekCalc from './other/DayOfWeekCalc';
import MileageCalc from './other/MileageCalc';

export const CALC_REGISTRY = {
  // Financial
  'mortgage': MortgageCalc,
  'loan': LoanCalc,
  'auto-loan': AutoLoanCalc,
  'interest': InterestCalc,
  'compound-interest': CompoundInterestCalc,
  'retirement': RetirementCalc,
  'amortization': AmortizationCalc,
  'investment': InvestmentCalc,
  'inflation': InflationCalc,
  'income-tax': IncomeTaxCalc,
  'salary': SalaryCalc,
  'sales-tax': SalesTaxCalc,
  'currency': CurrencyCalc,
  'roi': ROICalc,
  'discount': DiscountCalc,
  'percent-off': PercentOffCalc,
  'payment': PaymentCalc,
  'apr': APRCalc,
  'house-affordability': HouseAffordabilityCalc,
  'down-payment': DownPaymentCalc,
  'refinance': RefinanceCalc,
  '401k': Retirement401kCalc,
  'roth-ira': RothIRACalc,
  'budget': BudgetCalc,
  'credit-card': CreditCardCalc,
  'debt-payoff': DebtPayoffCalc,
  'credit-cards-payoff': CreditCardsPayoffCalc,
  'debt-consolidation': DebtConsolidationCalc,
  'student-loan': StudentLoanCalc,
  'take-home-pay': TakeHomePayCalc,
  'margin': MarginCalc,
  'lease': LeaseCalc,
  'annuity': AnnuityCalc,
  'ira': IRACalc,
  'rmd': RMDCalc,
  'business-loan': BusinessLoanCalc,
  'personal-loan': PersonalLoanCalc,
  'finance': FinanceCalc,
  'interest-rate': InterestRateCalc,
  'bond': BondCalc,
  'simple-interest': SimpleInterestCalc,
  'present-value': PresentValueCalc,
  'future-value': FutureValueCalc,
  'cd': CDCalc,
  'savings': SavingsCalc,
  'irr': IRRCalc,
  'debt-to-income': DebtToIncomeCalc,
  'depreciation': DepreciationCalc,
  'vat': VATCalc,
  'commission': CommissionCalc,
  'college-cost': CollegeCostCalc,
  'rent-vs-buy': RentVsBuyCalc,
  'rent': RentCalc,
  'social-security': SocialSecurityCalc,
  'average-return': AverageReturnCalc,
  'estate-tax': EstateTaxCalc,
  'pension': PensionCalc,
  'marriage-tax': MarriageTaxCalc,
  'repayment': RepaymentCalc,
  'boat-loan': BoatLoanCalc,
  'real-estate': RealEstateCalc,
  'rental-property': RentalPropertyCalc,
  'auto-lease': AutoLeaseCalc,
  'payback-period': PaybackPeriodCalc,
  'fha-loan': FHALoanCalc,
  'va-mortgage': VAMortgageCalc,
  'mortgage-payoff': MortgagePayoffCalc,
  'mortgage-amortization': MortgageAmortizationCalc,
  'heloc': HELOCCalc,
  'home-equity-loan': HomeEquityLoanCalc,
  'canadian-mortgage': CanadianMortgageCalc,
  'uk-mortgage': UKMortgageCalc,
  'annuity-payout': AnnuityPayoutCalc,
  'mutual-fund': MutualFundCalc,
  'cash-back': CashBackVsLowInterestCalc,
  'cash-back-vs-low-interest': CashBackVsLowInterestCalc,

  // Fitness
  'bmi': BMICalc,
  'anorexic-bmi': AnorexicBMICalc,
  'army-body-fat': ArmyBodyFatCalc,
  'bac': BACCalc,
  'body-type': BodyTypeCalc,
  'carbohydrate': CarbohydrateCalc,
  'fat-intake': FatIntakeCalc,
  'healthy-weight': HealthyWeightCalc,
  'overweight': OverweightCalc,
  'due-date': DueDateCalc,
  'conception': ConceptionCalc,
  'pregnancy-conception': ConceptionCalc,
  'pregnancy-weight-gain': PregnancyWeightGainCalc,
  'gfr': GFRCalc,
  'calorie': CalorieCalc,
  'body-fat': BodyFatCalc,
  'bmr': BMRCalc,
  'ideal-weight': IdealWeightCalc,
  'pace': PaceCalc,
  'pregnancy': PregnancyCalc,
  'tdee': TDEECalc,
  'macro': MacroCalc,
  'macronutrient': MacroCalc,
  'protein': ProteinCalc,
  'one-rep-max': OneRepMaxCalc,
  'target-heart-rate': TargetHRCalc,
  'body-surface-area': BSACalc,
  'lean-body-mass': LBMCalc,
  'calories-burned': CaloriesBurnedCalc,
  'ovulation': OvulationCalc,
  'period': PeriodCalc,
  'estimated-energy': TDEECalc,

  // Math
  'scientific': ScientificCalc,
  'graph': GraphTool,
  'fraction': FractionCalc,
  'percentage': PercentageCalc,
  'random-number': RandomNumberCalc,
  'triangle': TriangleCalc,
  'standard-deviation': StandardDeviationCalc,
  'quadratic': QuadraticCalc,
  'area': AreaCalc,
  'volume': VolumeCalc,
  'statistics': StatisticsCalc,
  'root': RootCalc,
  'exponent': ExponentCalc,
  'logarithm': LogarithmCalc,
  'modulo': ModuloCalc,
  'prime-factorization': PrimeFactorizationCalc,
  'circle': CircleCalc,
  'right-triangle': RightTriangleCalc,
  'pythagorean': PythagoreanCalc,
  'distance': DistanceCalc,
  'slope': SlopeCalc,
  'ratio': RatioCalc,
  'binary': BinaryCalc,
  'hex': HexCalc,
  'gcf': GCFCalc,
  'lcm': LCMCalc,
  'factor': FactorCalc,
  'common-factor': CommonFactorCalc,
  'mean-median': MeanMedianModeRangeCalc,
  'probability': ProbabilityCalc,
  'surface-area': SurfaceAreaCalc,
  'matrix': MatrixCalc,
  'half-life': HalfLifeCalc,
  'rounding': RoundingCalc,
  'permutation': PermutationCalc,
  'z-score': ZScoreCalc,

  // NEW top-level math tools
  'basic': BasicCalc,
  'big-number': BigNumberCalc,
  'scientific-notation': ScientificNotationCalc,
  'percent-error': PercentErrorCalc,
  'p-value': PValueCalc,
  'average': AverageCalc,

  // Fraction sub-calculators
  'fraction-simplify': FractionSimplifyCalc,
  'decimal-to-fraction': DecimalToFractionCalc,
  'fraction-to-decimal': FractionToDecimalCalc,
  'mixed-number': MixedNumberCalc,
  'big-number-fraction': BigFractionCalc,

  // Volume sub-calculators
  'cube-volume': CubeVolume,
  'sphere-volume': SphereVolume,
  'cone-volume': ConeVolume,
  'cylinder-volume': CylinderVolume,
  'ellipsoid-volume': EllipsoidVolume,
  'capsule-volume': CapsuleVolume,
  'rectangular-tank-volume': RectTankVolume,
  'spherical-cap-volume': SphericalCapVolume,
  'conical-frustum-volume': ConicalFrustumVolume,
  'square-pyramid-volume': SquarePyramidVolume,
  'tube-volume': TubeVolume,

  // Slope sub-calculators
  'slope-two-points': SlopeTwoPoints,
  'slope-point-slope': SlopePointSlope,

  // Distance sub-calculators
  'distance-2d': Distance2D,
  'distance-3d': Distance3D,
  'distance-lat-lon': DistanceLatLon,

  // Area sub-calculators
  'area-sector': AreaSector,
  'area-triangle': AreaTriangle,

  // Ratio sub-calculator
  'ratio-scaling': RatioScaling,
  'sample-size': SampleSizeCalc,
  'number-sequence': NumberSequenceCalc,
  'confidence-interval': ConfidenceIntervalCalc,
  'long-division': LongDivisionCalc,

  // Other
  'age': AgeCalc,
  'date': DateCalc,
  'time': TimeCalc,
  'hours': HoursCalc,
  'gpa': GPACalc,
  'grade': GradeCalc,
  'password': PasswordCalc,
  'conversion': ConversionCalc,
  'love': LoveCalc,
  'day-counter': DayCounter,
  'gas-mileage': GasMileageCalc,
  'tire-size': TireSizeCalc,
  'concrete': ConcreteCalc,
  'roman-numeral': RomanNumeralCalc,
  'wind-chill': WindChillCalc,
  'heat-index': HeatIndexCalc,
  'square-footage': SquareFootageCalc,
  'sleep': SleepCalc,
  'ohms-law': OhmsLawCalc,
  'fuel-cost': FuelCostCalc,
  'ip-subnet': IPSubnetCalc,
  'subnet': IPSubnetCalc,
  'bandwidth': BandwidthCalc,
  'time-card': TimeCardCalc,
  'time-duration': TimeDurationCalc,
  'btu': BTUCalc,
  'horsepower': HorsepowerCalc,
  'engine-horsepower': EngineHorsepowerCalc,
  'countdown': CountdownCalc,
  'shoe-size': ShoeSizeCalc,
  'mileage': MileageCalc,
  'gravel': GravelCalc,
  'mulch': MulchCalc,
  'tile': TileCalc,
  'roman-numeral-date': RomanNumeralDateCalc,
  'speed': SpeedCalc,
  'density': DensityCalc,
  'mass': MassCalc,
  'weight-converter': WeightConverterCalc,
  'weight': WeightCalc,
  'molarity': MolarityCalc,
  'molecular-weight': MolecularWeightCalc,
  'resistor': ResistorCalc,
  'base64': Base64Calc,
  'url-encode-decode': UrlEncodeDecodeCalc,
  'url-decoder': UrlEncodeDecodeCalc,
  'electricity': ElectricityCalc,
  'gdp': GDPCalc,
  'economy': GDPCalc,
  'tip': TipCalc,
  'golf-handicap': GolfHandicapCalc,
  'day-of-week': DayOfWeekCalc,
  'dice-roller': DiceRollerCalc,
  'dew-point': DewPointCalc,
  'height': HeightCalc,
  'time-zone': TimeZoneCalc,
  'stair': StairCalc,
  'roofing': RoofingCalc,
  'wire-gauge': VoltageDropCalc,
  'voltage-drop': VoltageDropCalc,
  'bra-size': BraSizeCalc,
  'ring-size': ShoeSizeCalc
};
